"use client";
import Image from "next/image";
import { AspectRatio, Stack, Heading, SimpleGrid } from "@chakra-ui/react";
import { useSectionHeadingVariant } from "@/theme/components/useSectionHeading";
import { TECH_PARTNERS_CONSTANTS } from "./techPartners.constants";

const TechPartners = () => {
  const HeadingVariant = useSectionHeadingVariant();
  const { title, list } = TECH_PARTNERS_CONSTANTS;
  return (
    <Stack spacing={10}>
      <Heading variant={HeadingVariant} textAlign={"center"} px={2}>
        {title}
      </Heading>
      <Stack borderRadius={"8px"} className="brand-shadow" spacing={8} py={10}>
        <SimpleGrid
          columns={{ base: 6, md: 8 }}
          columnGap={{ base: 3, sm: 4, md: 5 }}
          justifyContent={"center"}
          alignItems={"center"}
          rowGap={10}
          p={{ base: 3, md: 5 }}
        >
          {list.map((customer, index) => {
            return (
              <AspectRatio ratio={2 / 1} key={index} position="relative" maxW="130px">
                <Image
                  src={customer}
                  alt={`Customer ${index + 1}`}
                  fill
                  style={{
                    objectFit: "contain",
                    objectPosition: "center",
                  }}
                />
              </AspectRatio>
            );
          })}
        </SimpleGrid>
      </Stack>
    </Stack>
  );
};

export default TechPartners;
